export default {
  prod: 'https://bbot.menu/',
  staging: 'https://staging.bbot.menu/',
  demo: 'https://demo.bbot.menu/',
  dev: 'https://dev.bbot.menu/',
  master: 'http://localhost:8000/',
  gilles: 'http://192.168.1.2:8000/',
};
